import React, { useState, useEffect } from 'react'
import {
  setDeploymentCallback,
  startVersionPolling,
} from '../helpers/versionCheck'

const bannerStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  zIndex: 9999,
  backgroundColor: '#1976d2',
  color: '#fff',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: '12px 24px',
  fontSize: '14px',
  gap: '16px',
  boxShadow: '0 2px 8px rgba(0, 0, 0, 0.2)',
}

const buttonStyle = {
  backgroundColor: '#fff',
  color: '#1976d2',
  border: 'none',
  padding: '6px 16px',
  borderRadius: '4px',
  cursor: 'pointer',
  fontWeight: 600,
  fontSize: '13px',
}

const dismissStyle = {
  background: 'none',
  border: 'none',
  color: '#fff',
  cursor: 'pointer',
  fontSize: '18px',
  marginLeft: '8px',
  padding: '0 4px',
}

export default function DeploymentBanner() {
  const [visible, setVisible] = useState(false)

  useEffect(() => {
    setDeploymentCallback(() => setVisible(true))
    const intervalId = startVersionPolling()
    return () => clearInterval(intervalId)
  }, [])

  if (!visible) return null

  const handleRefresh = async () => {
    if ('caches' in window) {
      const cacheNames = await caches.keys()
      await Promise.all(cacheNames.map((name) => caches.delete(name)))
    }
    window.location.reload()
  }

  return (
    <div style={bannerStyle}>
      <span>
        A new version of Photobridge has been deployed. Please clear your cache
        and refresh to get the latest features.
      </span>
      <button style={buttonStyle} onClick={handleRefresh}>
        Refresh Now
      </button>
      <button style={dismissStyle} onClick={() => setVisible(false)}>
        ✕
      </button>
    </div>
  )
}
